import { IBaseResponseModel } from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import {
  ECommonBlogSeo,
  ECommonPageSeo,
  EContentResponse,
  ESeoResponse,
} from "../../models/seo";

const API = ApiEndpoints.SEO;
const baseURL = envConfig.API_ENDPOINT;

const getCommonPageSeo = async (
  pageName: string,
  language: string,
): Promise<IBaseResponseModel<ECommonPageSeo>> => {
  return api.get(
    baseURL,
    API.GetCommonPageSeo.url +
      "?pageName=" +
      pageName +
      "&language=" +
      language,
  );
  //return res;
};

const getCommonBlogSeo = async (
  blogId: string,
  language: string,
): Promise<IBaseResponseModel<ECommonBlogSeo>> => {
  return api.get(
    baseURL,
    API.GetCommonBlogSeo.url + "?blogId=" + blogId + "&language=" + language,
  );
  //return res;
};
const getSeoByObjId = async (
  objId: string,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.get(baseURL, API.Get_Seo.url + "?objId=" + objId);
  //return res;
};

const updateContent = async (
  data: EContentResponse,
): Promise<IBaseResponseModel<EContentResponse>> => {
  return api.put(baseURL, API.Update_Content.url, data);
  //return res;
};

const updateSeo = async (
  data: ESeoResponse,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.put(baseURL, API.Update_Seo.url, data);
  //return res;
};

const createSeo = async (
  data: ESeoResponse,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.post(baseURL, API.Create_Seo.url, data);
  //return res;
};

const SeoService = {
  getCommonPageSeo,
  getCommonBlogSeo,
  getSeoByObjId,
  updateContent,
  updateSeo,
  createSeo,
};

export default SeoService;
